import React from "react";
import {
	makeStyles,
	StyledComponentProps,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	withStyles
} from "@material-ui/core";
import {defaultStyles} from "../../styles/defaultStyles";
import EGinDocument from "../../models/EGinDocument";
import EGinDocumentsTableRow from "./EGinDocumentsTableRow";

const useStyles = makeStyles(defaultStyles);

interface IProps {
	egins: EGinDocument[];
	onEdit: (document: EGinDocument) => void;
	onDelete: (document: EGinDocument) => void;
}

type Props = IProps & StyledComponentProps;

const EGinDocumentsTable: React.FunctionComponent<Props> = (props: Props) => {
	const classes = useStyles({});

	const onEdit = (document: EGinDocument) => () => {
		props.onEdit(document);
	};

	const onDelete = (document: EGinDocument) => () => {
		props.onDelete(document);
	};

	const {egins} = props;
	return (
		<Table size={"small"}>
			<TableHead>
				<TableRow>
					<TableCell className={classes.tableHeader}>Document Number</TableCell>
					<TableCell className={classes.tableHeader}>Document Date</TableCell>
					<TableCell className={classes.tableHeader}>Description</TableCell>
					<TableCell className={classes.tableHeader}>Client</TableCell>
					<TableCell className={classes.tableHeader} style={{width: 152, textAlign:"center"}}>Actions</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{egins.map((doc) => <EGinDocumentsTableRow key={doc.id} document={doc} onEdit={onEdit(doc)} onDelete={onDelete(doc)}/>)}
			</TableBody>
		</Table>
	);
};

export default withStyles(defaultStyles)(EGinDocumentsTable);